<template>
  <div class="not-found-container">
    <div class="content-wrapper">
      <!-- 404 图标/插画 -->
      <div class="error-illustration">
        <div class="number-404">
          <span class="num">4</span>
          <span class="num zero">0</span>
          <span class="num">4</span>
        </div>
        <div class="illustration-icon">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="100" r="80" fill="#f0f0f0" />
            <path d="M60 80 Q100 40 140 80" stroke="#999" stroke-width="4" fill="none" />
            <circle cx="75" cy="95" r="8" fill="#666" />
            <circle cx="125" cy="95" r="8" fill="#666" />
            <path d="M70 130 Q100 150 130 130" stroke="#666" stroke-width="4" fill="none" />
          </svg>
        </div>
      </div>

      <!-- 错误信息 -->
      <div class="error-message">
        <h1 class="title">{{ $t('common.notFound.title') }}</h1>
        <p class="subtitle">{{ $t('common.notFound.subtitle') }}</p>
        <p class="description">{{ $t('common.notFound.description') }}</p>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button class="btn btn-primary" @click="goHome">{{ $t('common.notFound.backHome') }}</button>
        <button class="btn btn-secondary" @click="goBack">{{ $t('common.notFound.goBack') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goHome() {
      // 判断当前是移动端还是PC端
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      
      if (isMobile) {
        this.$router.push("/mobile/home");
      } else {
        this.$router.push("/home");
      }
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.goHome();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.not-found-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.content-wrapper {
  text-align: center;
  max-width: 600px;
  width: 100%;
}

.error-illustration {
  margin-bottom: 40px;
  animation: float 3s ease-in-out infinite;
}

.number-404 {
  font-size: 120px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.num {
  display: inline-block;
  
  &.zero {
    position: relative;
    
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      z-index: -1;
    }
  }
}

.illustration-icon {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  
  svg {
    width: 100%;
    height: 100%;
  }
}

.error-message {
  margin-bottom: 40px;
  color: white;
}

.title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 15px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.subtitle {
  font-size: 18px;
  margin-bottom: 10px;
  opacity: 0.9;
}

.description {
  font-size: 16px;
  opacity: 0.8;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 14px 32px;
  font-size: 16px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.btn-primary {
  background: white;
  color: #667eea;
  
  &:hover {
    background: #f8f9fa;
  }
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .not-found-container {
    padding: 15px;
  }
  
  .number-404 {
    font-size: 80px;
    gap: 5px;
  }
  
  .num.zero::after {
    width: 40px;
    height: 40px;
  }
  
  .illustration-icon {
    width: 150px;
    height: 150px;
  }
  
  .error-illustration {
    margin-bottom: 30px;
  }
  
  .title {
    font-size: 28px;
  }
  
  .subtitle {
    font-size: 16px;
  }
  
  .description {
    font-size: 14px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 12px;
  }
  
  .btn {
    width: 100%;
    padding: 12px 24px;
    font-size: 15px;
  }
}

// 小屏幕手机适配
@media screen and (max-width: 480px) {
  .number-404 {
    font-size: 60px;
  }
  
  .num.zero::after {
    width: 30px;
    height: 30px;
  }
  
  .illustration-icon {
    width: 120px;
    height: 120px;
  }
  
  .title {
    font-size: 24px;
  }
  
  .subtitle {
    font-size: 14px;
  }
  
  .description {
    font-size: 13px;
  }
}
</style>
